/**
 * @file ExternalNav/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const EXTERNAL_LINKS = [
    {
        link: "//www.cbc.ca/news/",
        title: "News",
        type: "external",
    },
    {
        link: "//www.cbc.ca/sports/",
        title: "Sports",
        type: "external",
    },
    {
        link: "//www.cbc.ca/radio/",
        title: "Radio",
        type: "external",
    },
    {
        link: "//www.cbc.ca/television/",
        title: "TV",
        type: "external",
    },
    {
        link: "//www.cbc.ca/sitemap/",
        title: "Discover",
        type: "external",
    },
];
